export default __webpack_public_path__ + "static/media/Isolatie-popup-image.525b88a1.png";